
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconVPink = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 23,
  height: 17,
  viewBox: "0 0 23 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.433 16.407c-.379.375-.89.588-1.423.593a2.077 2.077 0 0 1-1.477-.593L0 10.807l2.965-2.909 4.104 4.148L19.82 0l2.847 2.969L8.433 16.407z",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "evenodd"
})));

      const __svgRaw = "<svg width=\"23\" height=\"17\" viewBox=\"0 0 23 17\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M8.433 16.407c-.379.375-.89.588-1.423.593a2.077 2.077 0 0 1-1.477-.593L0 10.807l2.965-2.909 4.104 4.148L19.82 0l2.847 2.969L8.433 16.407z\" fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"evenodd\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-v-pink.386ab34cc14708b628368c7019be4083.svg"),
        {
          React: SvgIconVPink,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      